export default __webpack_public_path__ + "static/media/cancel.ee71b68c.svg";